<!-- <div @opacity *ngIf="status == true" class="fixed w-screen h-screen bg-black/50 top-0 left-0" style="z-index: 99998;">

</div>
 -->

<!-- <div *ngIf="status == true" class="w-screen h-screen top-0  left-0 fixed" style="z-index: 9999999998;">

    <div  class="w-full h-full bg-red-950/60 text-white backdrop-blur-xl"
        ></div>

    
</div>
 -->

<!-- <div @fadeInOutWithBlur *ngIf="status"
    class="bg-transparent backdrop-brightness-75 text-white  top-0  left-0 flex flex-col justify-center items-center"
    style="z-index: 999!important;height: 100vh!important;width: 100vw !important;position: fixed !important;">

    <div class="w-full h-full fixed top-0 left-0 z-10" (click)="close()"></div>



    <div [@dialogAnimation]="show" class="card max-h-screen overflow-auto z-20 ">

        <div class="w-full flex justify-end" (click)="close()">

            <div
                class="p-2 hover:bg-primary-300 hover:text-white text-primary-500 rounded-full transition-all duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="w-8 h-8  cursor-pointer">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M18 6l-12 12" />
                    <path d="M6 6l12 12" />
                </svg>
            </div>
        </div>

        <ng-content>

        </ng-content>
    </div>


</div> -->

<!-- <mat-dialog-content> -->

    <ng-template #content>
        <div class="w-full h-full flex flex-col justify-center items-center">
            <div class="w-full flex justify-end" (click)="close()">

                <div
                    class="p-2 hover:bg-primary-300 hover:text-white text-primary-500 rounded-full transition-all duration-300">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="w-8 h-8  cursor-pointer">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M18 6l-12 12" />
                        <path d="M6 6l12 12" />
                    </svg>
                </div>
            </div>
            <ng-content [select]="content" ></ng-content>
        </div>
   
    </ng-template>
<!-- </mat-dialog-content> -->

<!-- <ejs-dialog [@dialogAnimation]="status" class="p-0 m-0 " [target]="targetElement" [closeOnEscape]="closeOnEscape" [showCloseIcon]="showCloseIcon"
 [height]="height" [width]="width" [isModal]="isModal" [visible]="visible" [animationSettings]="dialogAnimation"
 (beforeOpen)="beforeOpen($event)" (beforeClose)="beforeClose($event)" (open)="afterOpen($event)"
 (close)="afterClose($event)">

 <ng-template #header>

     <div class="dialog-header-text">
         {{dialogHeaderTextParsed}}
     </div>
 </ng-template>

 <ng-template #content>
     <ng-content [select]="content">

     </ng-content>
 </ng-template>

</ejs-dialog> -->